module.exports = __webpack_public_path__ + "img/default.0f439bf4.png";